import * as yup from 'yup'
import moment from 'moment'

/**
 * Shared date of birth validator used across onboarding forms.
 *
 * Validates that the date of birth:
 * - Is required
 * - Is not in the future
 * - Represents a person at least 18 years old
 */
export const dateOfBirthValidator = yup
    .string()
    .required('Please enter your date of birth')
    .test('not-in-future', 'Date of birth cannot be in the future', (value) => {
        if (!value) return false
        return moment(value).isSameOrBefore(moment(), 'day')
    })
    .test('is-18', 'You must be at least 18 years old', (value) => {
        if (!value) return false
        return moment(value).isSameOrBefore(moment().subtract(18, 'years'), 'day')
    })
